import { useEffect, useState } from "react"
import styles from "@css/modules/ListingPricing.module.scss"
import dynamic from "next/dynamic"
import { Listing } from "@t/Listing"

const Component = dynamic(() => import("./DynamicModal"), { ssr: false })

export function BugReport({ enabled, listing }: { enabled: boolean; listing: Listing }) {
    const [isVisible, setIsVisible] = useState(false)
    const [element, setElement] = useState(null)
    useEffect(() => {
        const container = document.getElementById("dialog-portal")
        const el = document.createElement("div")
        setElement(el)
        container.appendChild(el)
        return () => {
            container.removeChild(el)
        }
    }, [])
    if (!enabled || !element) return null

    return (
        <>
            <button className={styles.reportBug} onClick={() => setIsVisible(true)}>
                Report an error
            </button>
            {isVisible && <Component setIsVisible={setIsVisible} listing={listing} />}
        </>
    )
}
